module.exports = __webpack_public_path__ + "static/logoVNosotras-76a5902d209386414f89f110798c5a20.png";